export default {
    loader:false
}